import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Player, PlayerBackend } from './player.interfaces';
import { defaultSelectors, defaultDispatchers } from './players.slice';
import { ReduxRepository } from '../reduxRepository';
import { PlayerTranslator } from './player.translator';
import { createPlayerThunk } from './playerCreate.thunk';
import { updatePlayerThunk } from './playerUpdate.thunk';
import { deletePlayerThunk } from './playerDelete.thunk';
import { store } from '../../store';
import { loadPlayersThunk } from './playersLoad.thunk';

@injectable()
export class PlayerRepository extends ReduxRepository<Player, PlayerBackend> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<PlayerBackend>,
  ) {
    super(
      ModelTypes.Player,
      new PlayerTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createPlayerThunk,
      updatePlayerThunk,
      deletePlayerThunk,
      loadPlayersThunk,
    );
  }

  getPlayer(id: string) {
    return this.selectors
      .resourcesSelector(store.getState())
      .find((player) => player.id === id);
  }

  getPlayerByAccount(accountId: string) {
    return this.selectors
      .resourcesSelector(store.getState())
      .find((player) => player.accountId === accountId);
  }

  update(playerId: string, partialPlayer: Partial<Player>) {
    this.dispatchUpdate({
      ...partialPlayer,
      id: playerId,
    });
  }
}
